export class AnnouncementsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async getActive() {
        return this.client.get('/api/announcements/active');
    }
}
//# sourceMappingURL=announcements-api.js.map